import * as actions from '../../../actions/team/lineups'

export default (state = actions.getTeamLineupsInitialState(), action = {}) => {
  switch (action.type) {
    case actions.TEAMS_TEAM_LINEUPS_DELETE_FETCH: {
      const lineup = state.data.find((l) => l.id === action.payload.lineupId)
      if (lineup) {
        lineup.deleted = true
      }
      return { ...state, serverResponse: { loading: true } }
    }

    case actions.TEAMS_TEAM_LINEUPS_DELETE_FETCH_CANCELED: {
      const lineup = state.data.find((l) => l.id === action.payload.originalAction.payload.lineupId)
      if (lineup) {
        lineup.deleted = false
      }
      return { ...state, serverResponse: { loading: false } }
    }
    case actions.TEAMS_TEAM_LINEUPS_DELETE_FETCH_ERROR: {
      const lineup = state.data.find((l) => l.id === action.payload.originalAction.payload.lineupId)
      if (lineup) {
        lineup.deleted = false
      }
      return { ...state, serverResponse: { ...action.payload, loaded: true } }
    }
    case actions.TEAMS_TEAM_LINEUPS_DELETE_FETCH_FULFILLED: {
      return { ...state, serverResponse: { ...action.payload, loaded: true } }
    }
    case actions.TEAMS_TEAM_LINEUPS_FETCH: {
      return { ...state, loading: true }
    }

    case actions.TEAMS_TEAM_LINEUPS_FETCH_CANCELED: {
      return { ...state, loading: false }
    }
    case actions.TEAMS_TEAM_LINEUPS_FETCH_ERROR: {
      return { ...state, ...action.payload, loaded: true }
    }
    case actions.TEAMS_TEAM_LINEUPS_FETCH_FULFILLED: {
      return { ...state, ...action.payload, loaded: true }
    }
    case actions.TEAMS_TEAM_LINEUPS_RESET: {
      return actions.getTeamLineupsInitialState()
    }

    case actions.TEAMS_TEAM_LINEUPS_RESTORE_FETCH: {
      const lineup = state.data.find((l) => l.id === action.payload.lineupId)
      if (lineup) {
        lineup.deleted = false
      }
      return { ...state, serverResponse: { loading: true } }
    }
    case actions.TEAMS_TEAM_LINEUPS_RESTORE_FETCH_CANCELED: {
      const lineup = state.data.find((l) => l.id === action.payload.originalAction.payload.lineupId)
      if (lineup) {
        lineup.deleted = true
      }
      return { ...state, serverResponse: { loading: false } }
    }
    case actions.TEAMS_TEAM_LINEUPS_RESTORE_FETCH_ERROR: {
      const lineup = state.data.find((l) => l.id === action.payload.originalAction.payload.lineupId)
      if (lineup) {
        lineup.deleted = true
      }
      return { ...state, serverResponse: { ...action.payload, loaded: true } }
    }
    case actions.TEAMS_TEAM_LINEUPS_RESTORE_FETCH_FULFILLED: {
      return { ...state, serverResponse: { ...action.payload, loaded: true } }
    }

    default:
  }
  return state
}
